// extracted by mini-css-extract-plugin
export default {"modalOverlay":"ID-z","modalContent":"JD-z","header":"KD-z","close":"LD-z"};